import { render, staticRenderFns } from "./EstimageMessageNewSideMenu.vue?vue&type=template&id=07675f96"
import script from "./EstimageMessageNewSideMenu.vue?vue&type=script&lang=js"
export * from "./EstimageMessageNewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports